import React, { useEffect, useState, useContext } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../services/timesheetreportsService';
import {timesheetService} from '../services/timesheetService';
import {formatterhelper} from '../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {loader} from '../compnents/loadermd';
var XLSX = require("xlsx");
const ProductivityReports = () => {

    const [formData, setFormData] = useState({
        fromdate: '',
        todate: '',
        employee: '',
        client: 'ALL',
        subclient: 'ALL',
      });
    const [datacomp,setDatacomp] = useState([]); 
    const [datareport,setDatareport] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [empcomp,setempcomp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [isloaded,setloading] = useState(true);
    
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [errors, setErrors] = useState({});
     
    useEffect(()=>{
        getemplist();
        _getclientslist();
    },[]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
        
        if(name == 'client'){
            _getsubclient({clientid:value}); 
        }

      };


    const validateForm = () => {
        let valid = true;
        const newErrors = {};

        if (formData.fromdate == '') {
            newErrors.fromdate = 'From date is required';
            valid = false;
        }

        if (formData.todate == '') {
            newErrors.todate = 'Todate is required';
            valid = false;
        }

        if(formData.todate < formData.fromdate){
            newErrors.todate = 'Todate should be grater than fromdate';
            valid = false;
        }

        if (formData.client == '') {
          newErrors.client = 'Client name is required';
          valid = false;
        }

        if (formData.subclient == '') {
            newErrors.subclient = 'Subclient name is required';
            valid = false;
        }
        
        if (formData.employee == '') {
            newErrors.employee = 'Employee is required';
            valid = false;
        }

        setErrors(newErrors);

       return valid; 
    }  

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!validateForm()){
            return;
        }

        let reportobj = {
          'clientid':formData.client,
          'employeeid':formData.employee,
          'frmdt':formatterhelper.dateformatter({date:formData.fromdate}),
          'todt':formatterhelper.dateformatter({date:formData.todate}),
          'subclientid':formData.subclient
        };

        console.log(reportobj);
        // setfilterobj(reportobj);
        getreports({reportobj:reportobj});
        // Now you can perform any further actions with the form data
      };

    function getreports({reportobj}){
        let emparr = [];
        setloading(false);
        timesheetreportService.productivityreports({obj:reportobj})
        .then((response)=>{
            // console.log('get reports');
            // console.log(response.data);

            if(response.status == 200){
                response.data.data.forEach((value,index) =>{
                    emparr.push((<tr key={index}>
                        <th>{index + 1}</th>
                        <td>{value.client}</td>
                        <td>{value.subclient}</td>
                        <td>{value.budget_hours}</td>
                        <td>{value.actual_hours}</td>
                        <td>{value.billed_hours}</td>
                        <td>{value.qafullhours}</td>
                    </tr>));
                }); 
            
                // let totalpage = response.data.data.total; 
                // setPages(totalpage);
                setDatareport(response.data.data);
                setDatacomp(emparr);
                setDatastate(true);
                setloading(true);
            }else{
                setDatacomp([]);  
                setDatastate(false);
                setloading(true);
                // setPages(0);
            }
        }).catch((error)=>{
            setDatacomp([]); 
            setDatastate(false);
            setloading(true);
            // console.log(error);
            // setDatacomp([]);  
            // setDatastate(false);
            // setloading(true);
            // setPages(0);
        });
    }  

    function getemplist(){
        let member = userdata.id;
        let managerid = member;
        let emparr = [];
        timesheetreportService.getemployeelist({managerid:managerid}).then((response)=>{
           console.log(response);
           response.data.data.forEach((value,index) =>{
              emparr.push((<option value={value.id}>{value.name}</option>));
           });
           setempcomp(emparr);
        }).catch((error)=>{

        });  
    }

    function _getclientslist(){
        let managerid = 1;
        let emparr = [];
        timesheetreportService.getclientslist({managerid:managerid}).then((response)=>{
            console.log(response);
            response.data.data.forEach((value,index) =>{
                if(value.client != ''){
                    emparr.push((<option value={value.client}>{value.client}</option>));
                }
            });
            setClientscomp(emparr);
         }).catch((error)=>{
 
         });    
    }

    function _getsubclient({clientid}){

        try{
            let client = clientid;
            let emparr = [];
            // setreminloader(false);
            // setSubclientloader((<Smallloader/>));
            
            return timesheetService.getallsubclienttemp({client:client}).then((response)=>{
               if(response == undefined || response == '' || response.data.data == undefined){
                     return;
               }
               // console.log('response subclient');
               // console.log(response);
               response.data.data.forEach((value,index)=>{
                  emparr.push((<option key={index} value={value.subclient}>{value.subclient}</option>)); 
               });
               setsubClientscomp(emparr);
            //    setSubclientloader((<></>));
            //    setallsubClients(response.data.data);
            //    setreminloader(true);
               return response.data.data;
            }).catch((error)=>{
               console.log(error);  
            //    setSubclientloader((<></>));
            //    setreminloader(true);
            });   
         }catch(error){
            console.log(error);
         }
        // let _clientid = clientid;
        // let emparr = [];
        // timesheetService.getallsubclient({client:_clientid}).then((response)=>{
        //     console.log(response);
        //     response.data.data.forEach((value,index) =>{
        //         emparr.push((<option value={value.subclient}>{value.subclient}</option>));
        //     });
        //     setsubClientscomp(emparr);
        //  }).catch((error)=>{
 
        //  });   
    }

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
        let pageno = 1;
        if(event.first == 0){
         pageno = 1;    
        }else{
         pageno = ((event.first/rows) + 1);  
        }
        // getUsers(pageno);
        getreports({reportobj:filterobj,pageno:pageno});
        // console.log(pageno);
    };

    const exportexcel = () =>{
        if(datacomp.length <=0){
             return;
        }
        // getreports({reportobj:filterobj,pageno:pageno});
        let data = datareport;
        exportToExcel(data);
    }

    function exportToExcel(data) {
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
        XLSX.writeFile(wb, 'productivityreports.xlsx');
      }
   
    return (
        <>
            <div className="invisible-divider-sm"></div>
            <h6>Productivity Reports</h6>
            <div className='card card-custom-style card-style-padding'>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className="col-md-2">
                        <label className='pull-left'>From date</label>
                        <Calendar value={formData.fromdate} name="fromdate" onChange={handleChange} className='calender-custom-style' />
                        {errors.fromdate && <span className='error'>{errors.fromdate}</span>} 
                    </div>
                    <div className="col-md-2">
                        <label className='pull-left'>To date</label>
                        <Calendar value={formData.todate} name="todate" onChange={handleChange} className='calender-custom-style' />
                        {errors.todate && <span className='error'>{errors.todate}</span>} 
                    </div>
                    <div className="col-md-2">
                        <label className='pull-left'>Employee</label>
                        <select className='form-control' name="employee" value={formData.employee} onChange={handleChange}>
                            <option value=''>Select employee</option>
                            {empcomp}
                        </select>
                        {errors.employee && <span className='error'>{errors.employee}</span>} 
                    </div>
                    <div className="col-md-2">
                        <label className='pull-left'>Client</label>
                        <select className='form-control' name='client' value={formData.client} onChange={handleChange}>
                            <option value='ALL'>ALL</option>
                            {cleintscomp}
                        </select>
                    </div>
                    <div className="col-md-2">
                        <label className='pull-left'>Subclient</label>
                        <select className='form-control' name='subclient' value={formData.subclient} onChange={handleChange}>
                            <option value='ALL'>ALL</option>
                            {subclientscomp}
                        </select>
                    </div>
                    <div className="col-md-2">
                        <div className='button-wrapper-style'>
                            <Button type='submit' stype="button" label="Show" severity="success" rounded className='custom-btn-style' />
                            &nbsp;&nbsp;&nbsp; 
                            <Button type='button' stype="button" label="Export" severity="info" rounded className='custom-btn-style' onClick={()=>exportexcel()} />
                        </div>
                        
                    </div>
                   
                </div>
                </form>
            </div>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <div className='row'>
                    <div className='col-md-6'></div>
                    <div className='pagination col-md-6'>
                        {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
                        {isloaded && dataavail ? (<Paginator first={first} rows={rows} totalRecords={totalpages} rowsPerPageOptions={[15]} onPageChange={onPageChange} />) : (<></>)}
                        
                    </div>
                </div>
               
                <div className='row'>
                <div className='col-md-12'> 
                    {!isloaded ? loader.Loadermd() : dataavail ?
                    (<table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Sr No</th>
                                <th scope="col">Client</th>
                                <th scope="col">Subclient</th>
                                <th scope="col">Budget hours</th>
                                <th scope="col">Actual hours</th>
                                <th scope="col">Billable hours</th>
                                <th scope="col">QA Full Hours</th>
                            </tr>
                        </thead>
                        <tbody>
                            {datacomp}
                        </tbody>
                    </table>)
                     : (<p>No data Found</p>)} 
                     </div>
                </div>
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default ProductivityReports;